var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10250",
    "data-name": "\\uD328\\uC2A4 10250",
    d: "M0,23.962Z",
    transform: "translate(0 -23.962)",
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21663",
    "data-name": "\\uADF8\\uB8F9 21663",
    transform: "translate(-870 -203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28105",
    "data-name": "\\uC0AC\\uAC01\\uD615 28105",
    width: 32,
    height: 32,
    transform: "translate(870 203)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21662",
    "data-name": "\\uADF8\\uB8F9 21662",
    transform: "translate(-2.484 -1.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21660",
    "data-name": "\\uADF8\\uB8F9 21660",
    transform: "translate(872.484 207.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10251",
    "data-name": "\\uD328\\uC2A4 10251",
    d: "M31.917,11.543q-.595-5.012-5.535-8.066A17.3,17.3,0,0,0,15.056,1.134,17.079,17.079,0,0,0,4.575,5.9q-4.1,4.058-3.5,9.071a10.6,10.6,0,0,0,5.087,7.794,1.352,1.352,0,0,1,.533,1.563,17.537,17.537,0,0,1-.864,2.11,1.36,1.36,0,0,0,1.548,1.876,17.678,17.678,0,0,0,6.561-2.6,1.44,1.44,0,0,1,.905-.256,18.573,18.573,0,0,0,3.092-.08,17.075,17.075,0,0,0,10.481-4.768Q32.512,16.557,31.917,11.543Z",
    transform: "translate(-0.292 -1)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_1",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 1",
    transform: "translate(0 21.681)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10249",
    "data-name": "\\uD328\\uC2A4 10249",
    d: "M26.756,9.783a8.972,8.972,0,0,0-4.612-6.719A14.413,14.413,0,0,0,12.71,1.112,14.229,14.229,0,0,0,3.979,5.084a8.821,8.821,0,0,0-2.916,7.557A8.827,8.827,0,0,0,5.3,19.134a1.127,1.127,0,0,1,.444,1.3,14.609,14.609,0,0,1-.72,1.758,1.133,1.133,0,0,0,1.289,1.563,14.727,14.727,0,0,0,5.466-2.165,1.2,1.2,0,0,1,.754-.214,15.473,15.473,0,0,0,2.576-.067,14.225,14.225,0,0,0,8.732-3.972A8.819,8.819,0,0,0,26.756,9.783Z",
    transform: "translate(-0.41 -24.372)",
    fill: "#ff6a13",
    stroke: "#ff6a13",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_65",
    "data-name": "\\uC120 65",
    x2: 12.15,
    transform: "translate(7.162 -15.607)",
    fill: "none",
    stroke: "#ff6a13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_66",
    "data-name": "\\uC120 66",
    x2: 8.353,
    transform: "translate(10.959 -11.81)",
    fill: "none",
    stroke: "#ff6a13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1217",
    "data-name": "\\uD0C0\\uC6D0 1217",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(880.834 218.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1218",
    "data-name": "\\uD0C0\\uC6D0 1218",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(886.834 218.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1219",
    "data-name": "\\uD0C0\\uC6D0 1219",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(892.834 218.015)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewicon);
export default __webpack_public_path__ + "static/media/reviewicon.9d958afb00096176571898d809939fd6.svg";
export { ForwardRef as ReactComponent };